import React from 'react';
import { DataTable } from 'damco-components';
import { getEquipmentCols, getExportJobsCols, setSortForCBLTable } from 'views/job-costing/utils/CostAndRevenueHelpers';
import { ICostorRevenue, IEquipmentDetailsResponseData, IExportJobsResponseData } from 'reducers/bookings/models';
import { IStore } from 'reducers/index';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { fetchExportJobsChargeCost, fetchExportJobsChargeRev } from 'actions/costRevenue';
import { fetchEquipmentsExportJob } from 'actions/costRevenue';
import { resetSort, setPageEquipment, setPageExport, setSort } from 'actions/filters';
import { LoadingAnimation } from 'components/loading';
import CostColumnsData from 'views/job-costing/utils/CostColumnsData';
import { ISortModel } from 'reducers/filters/models';
import { ISort } from 'views/job-costing/search/models';
import { ViewTypes } from 'constants/chargeTypes';

  interface IMapDispatchToProps {
    fetchExportJobsChargeRev: (id: number, viewType?: number, pageSize?: number) => Promise<void>;
    fetchExportJobsChargeCost: (id: number, viewType?: number, pageSize?: number) => Promise<void>;
    fetchEquipmentsExportJob: (id: number, exportJobId: number, essoRateDetailId: number, page?: number, pageSize?: number) => Promise<void>;
    setPageEquipment: (page: number) => void;
    setPageExport: (page: number) => void;
    setSort: (sort: ISortModel) => void;
    resetSort: () => void;
  }
  interface IMapStateToProps {
    isFetchDataLoading: boolean;
    exportJobsChargeRev: IExportJobsResponseData;
    exportJobsChargeCost: IExportJobsResponseData;
    equipmentsForExportJob : IEquipmentDetailsResponseData;
    exportPage: number;
    equipmentPage: number;
  }
  interface IState {
      isExportJobsFetchinProgress: boolean;
      exportJobPage: number;
      exportJobPageSize: number;
      exportJobs: any[];
      totalCountExportJobs: number;
      isEventAdded: boolean,
      exportJobNumber: string;
      isEquipmentsFetchinProgress: boolean;
      equipmentDetails: any[],
      equipmentsPage: number;
      equipmentsPageSize: number;
      sorted: any[] | ISort[];
      setDefaultEquipmentsPage: boolean;
      totalEquipmentsCount: number,
      handleEquipmentCall: boolean
  }
  interface IExportJobsTableProps {
      id: string;
      chargeItem: ICostorRevenue;
      index: number;
      setCurrentIndex: (e: any) => void;
      cblId: number;
      target: string;
  }

  interface IProperties extends IExportJobsTableProps, IMapStateToProps, IMapDispatchToProps { }

  const exportJobsTable: string = '.ExportJobDetailsTable';
  const equipmentsTable: string = '.EquipmentsDetailsTable';

  class _ExportJobDetailsTable extends React.Component<IProperties, IState> {
    
    public myTableWrap: any = null;
    public myEqTableWrap: any = null;
    public viewType: number = 0;

    constructor(props: any){
        super(props)
        this.state = {
          isExportJobsFetchinProgress: true,
          exportJobPage: 1,
          exportJobPageSize: 10,
          exportJobs: [],
          totalCountExportJobs: 0,
          isEventAdded: false,
          exportJobNumber: '',
          isEquipmentsFetchinProgress: true,
          equipmentDetails: [],
          equipmentsPage: 1,
          equipmentsPageSize: 10,
          sorted: [],
          setDefaultEquipmentsPage: false,
          totalEquipmentsCount: 0,
          handleEquipmentCall: true
        }
    }
       public componentDidMount() {
        this.myTableWrap = document.querySelector(exportJobsTable);
        this.myEqTableWrap = document.querySelector(equipmentsTable);

        this.viewType = (Object.values(ViewTypes).indexOf(this.props.chargeItem.viewType) >= 0) ?
                          Object.values(ViewTypes).indexOf(this.props.chargeItem.viewType) :
                          0;

        if(this.props.target === CostColumnsData.TYPES.REVENUE) {
          this.props.fetchExportJobsChargeRev(this.props.chargeItem.id, this.viewType, this.state.exportJobPageSize);
        }
        else{
          this.props.fetchExportJobsChargeCost(this.props.chargeItem.id, this.viewType, this.state.exportJobPageSize);
        }
      }

        public componentDidUpdate = (prevProps:any, prevState:any) => {
            if ((prevProps.exportJobsChargeRev.data !== this.props.exportJobsChargeRev.data) || (prevProps.exportJobsChargeCost.data !== this.props.exportJobsChargeCost.data)) {
              this.setState({
                exportJobs: (this.props.target === CostColumnsData.TYPES.REVENUE) ? this.addIdForDataTable(this.props.exportJobsChargeRev.data) : this.addIdForDataTable(this.props.exportJobsChargeCost.data),
                totalCountExportJobs: (this.props.target === CostColumnsData.TYPES.REVENUE) ? this.props.exportJobsChargeRev.totalCount : this.props.exportJobsChargeCost.totalCount,
                exportJobPage: (this.props.target === CostColumnsData.TYPES.REVENUE) ? this.props.exportJobsChargeRev.page : this.props.exportJobsChargeCost.page,
                exportJobPageSize: (this.props.target === CostColumnsData.TYPES.REVENUE) ? this.props.exportJobsChargeRev.pageSize : this.props.exportJobsChargeCost.pageSize,
                exportJobNumber: (this.props.exportJobsChargeRev.data.length > 0 && (this.props.target === CostColumnsData.TYPES.REVENUE)) ?
                                  this.props.exportJobsChargeRev.data[this.props.index].exportJobNumber :
                                    ((this.props.exportJobsChargeCost.data.length > 0 && (this.props.target === CostColumnsData.TYPES.COST)) ?
                                      this.props.exportJobsChargeCost.data[this.props.index].exportJobNumber :
                                      '')
            })
              if(this.props.exportJobsChargeRev.data.length > 0 && (this.props.target === CostColumnsData.TYPES.REVENUE)) {
                this.props.fetchEquipmentsExportJob(this.props.cblId, this.props.exportJobsChargeRev.data[this.props.index].exportJobId, this.props.exportJobsChargeRev.data[this.props.index].essoRateDetailId, this.state.equipmentsPage, this.state.equipmentsPageSize);
                this.setState({
                  equipmentDetails: this.props.equipmentsForExportJob.data,
                })
              }
              else if(this.props.exportJobsChargeCost.data.length > 0 && (this.props.target === CostColumnsData.TYPES.COST)) {
                this.props.fetchEquipmentsExportJob(this.props.cblId, this.props.exportJobsChargeCost.data[this.props.index].exportJobId, this.props.exportJobsChargeCost.data[this.props.index].essoRateDetailId, this.state.equipmentsPage, this.state.equipmentsPageSize);
                this.setState({
                  equipmentDetails: this.props.equipmentsForExportJob.data,
                })
              }
              this.updatesComponentUpdate();
            }

          if(prevProps.index !== this.props.index) {
              if(this.props.exportJobsChargeRev.data.length > 0 || this.props.exportJobsChargeCost.data.length > 0) {
                this.setState({
                  exportJobNumber: (this.props.target === CostColumnsData.TYPES.REVENUE && this.props.exportJobsChargeRev.data.length > 0) ?
                                    this.props.exportJobsChargeRev.data[this.props.index].exportJobNumber :
                                      ((this.props.target === CostColumnsData.TYPES.COST && this.props.exportJobsChargeCost.data.length > 0) ?
                                      this.props.exportJobsChargeCost.data[this.props.index].exportJobNumber :
                                      ''),
                  isEventAdded: false,
                  equipmentDetails: this.props.equipmentsForExportJob.data,
                  equipmentsPage: this.props.equipmentsForExportJob.page,
                  equipmentsPageSize: this.props.equipmentsForExportJob.pageSize,
                  setDefaultEquipmentsPage: false
                })
              }
            this.props.setCurrentIndex(this.props.index);

          }
          if(this.props.equipmentsForExportJob.data.length > 0){
            if (prevProps.equipmentsForExportJob.data !== this.props.equipmentsForExportJob.data) {
              this.setState({
                isEquipmentsFetchinProgress: false,
                equipmentDetails: this.props.equipmentsForExportJob.data,
                equipmentsPageSize: this.props.equipmentsForExportJob.pageSize,
                totalEquipmentsCount: this.props.equipmentsForExportJob.totalCount,
                setDefaultEquipmentsPage: false
              })
            }
          }
        }

        public componentWillUnmount = () => {
          this.props.setCurrentIndex(0);
        }

        public addIdForDataTable = (list:any[]) =>{
          list.forEach((ele:any, idx:number)=>{
            ele.id = idx
          })
          return list
        }

      public render() {
        return (
            <div>
                <div className="modalChargeTable">
                    <div className="modalChargeHeader">
                      <div>Charge Item</div>
                      <div>Description</div>
                      <div>View Added</div>
                      <div>Quantity</div>
                      <div>UOM</div>
                      <div>Unit Price</div>
                      <div>Currency</div>
                      <div>Amount</div>
                    </div>
                    <div className="modalChargeRowGroup">
                        <div>{this.props.chargeItem.materialCode}</div>
                        <div>{this.props.chargeItem.materialDescription}</div>
                        <div>{this.props.chargeItem.viewType}</div>
                        <div>{this.props.chargeItem.quantity}</div>
                        <div>{this.props.chargeItem.uom}</div>
                        <div>{this.props.chargeItem.rate}</div>
                        <div>{this.props.chargeItem.condCurrency}</div>
                        <div>{Number(Number(this.props.chargeItem.quantity) * Number(this.props.chargeItem.rate)).toFixed(2)}</div>
                    </div>
                  </div>
                  {this.props.isFetchDataLoading && <LoadingAnimation smallLoad={true} />}
                {<DataTable
                        data={this.state.exportJobs}
                        columns={this.getExportJobsColumns(this.props.target)}
                        isSelectable={true}
                        isEditable={false}
                        isExpandable={false}
                        selectedOption="single"
                        manualPagination={true}
                        isSortable={true}
                        isResizable={true}
                        pageCount={Math.ceil(this.state.totalCountExportJobs / this.state.exportJobPageSize)}
                        showPagination={this.props.exportJobsChargeRev.totalCount > 0 || this.props.exportJobsChargeCost.totalCount > 0}
                        tableName={`ExportJobDetailsTable`}
                        fetchData={(exportJobs:any)=>{
                            this.tableOrderFetch(exportJobs);
                        }}
                    />}
                    <div className="mb-1">Showing equipments for <strong>{this.state.exportJobNumber}</strong></div>
                    {!this.state.setDefaultEquipmentsPage && <DataTable
                        data={this.state.equipmentDetails}
                        columns={this.getEquipmentColumns()}
                        isSelectable={false}
                        isEditable={false}
                        manualPagination={true}
                        isSortable={false}
                        isResizable={true}
                        pageCount={Math.ceil(this.state.totalEquipmentsCount / this.state.equipmentsPageSize)}
                        showPagination={this.props.equipmentsForExportJob.totalCount > 0}
                        tableName={`EquipmentsDetailsTable`}
                        fetchData={(equipmentDetails:any)=>{
                          if(this.state.handleEquipmentCall){
                            this.equipmentsTableOrderFetch(equipmentDetails);
                          }
                          else{
                            this.setState({
                                handleEquipmentCall: true
                              })
                          }
                        }}
                    />}
            </div>
        );
      }

        public setSelected = () => {
          let fetch: boolean = false;
          setTimeout(() => {
            if(!this.state.isEventAdded) {
              fetch = true;
            }
            const htmlEl = this.getTableRows(fetch);
            this.radioSelection(htmlEl);
          }, 500);
        }

        public radioSelection = (htmlEl: any) => {
          if (htmlEl) {
            const currentEl = htmlEl[this.props.index];
            if (currentEl && currentEl.parentElement) {
                if (currentEl.querySelector('input')) {
                    currentEl.classList.add('-selected');
                    currentEl.querySelector('input').checked = true;
                }
            }
          }
        }

        public getTableRows = (fetchData: boolean) => {
          if (!this.myTableWrap) {
              this.myTableWrap = document.querySelector(exportJobsTable)
          }
          if (this.myTableWrap) {
            const htmlEl = this.myTableWrap.querySelectorAll('.rt-tbody .rt-tr-group')
            if (htmlEl && htmlEl.length > 0) {
              // tslint:disable-next-line: prefer-for-of
              let totalrows: any;
              if(this.props.target === CostColumnsData.TYPES.REVENUE) {
                totalrows = htmlEl.length > this.props.exportJobsChargeRev.data.length ? this.props.exportJobsChargeRev.data.length : htmlEl.length
              }
              else{
                totalrows = htmlEl.length > this.props.exportJobsChargeCost.data.length ? this.props.exportJobsChargeCost.data.length : htmlEl.length
              }
              for (let i = 0; i < totalrows; i++) {
                if (htmlEl[i] && htmlEl[i].parentElement && i !== this.props.index) {
                  htmlEl[i].classList.remove('-selected')
                  if (htmlEl[i].querySelector('input') && !htmlEl[i].querySelector('input').hasAttribute('listenerOnClick')) {
                    htmlEl[i].querySelector('input').addEventListener('click', (e: any) => {
                      this.handleRadioSelection(e, i, fetchData)
                    })
                    htmlEl[i].querySelector('input').setAttribute('listenerOnClick', 'true')
                  }
                }
              }
              this.setState({isEventAdded: true})
            }
            return htmlEl
          }
        }

        public resetPagination = () => {
          if (!this.myEqTableWrap) {
              this.myEqTableWrap = document.querySelector(equipmentsTable)
          }
          if (this.myEqTableWrap) {
              const htmlEl = this.myEqTableWrap.querySelectorAll('.-pageJump');
              const htmlE2 = this.myEqTableWrap.querySelectorAll('.-previous');
              if (htmlEl && htmlEl.length > 0) {
                  // tslint:disable-next-line: prefer-for-of
                  htmlEl[0].querySelector('input').value = 1;
                  htmlE2[0].querySelector('button').click();
                }
              return htmlEl;
          }
        }

      public handleRadioSelection = (ev: any, index: number, fetchData: boolean) => {
          ev.preventDefault();
          ev.stopPropagation();
          this.setState(
            {
              setDefaultEquipmentsPage: true,
              handleEquipmentCall: false
            })
          this.props.setPageEquipment(1)

          switch(this.props.target) {
            case CostColumnsData.TYPES.REVENUE : {
              if(this.props.exportJobsChargeRev.data.length > 0 && fetchData && this.state.equipmentsPageSize > 0){
                this.props.fetchEquipmentsExportJob(this.props.cblId, this.props.exportJobsChargeRev.data[index].exportJobId, this.props.exportJobsChargeRev.data[index].essoRateDetailId, 1, this.state.equipmentsPageSize);
              }
              break;
            }
            case CostColumnsData.TYPES.COST :{
              if(this.props.exportJobsChargeCost.data.length > 0 && fetchData && this.state.equipmentsPageSize > 0){
                this.props.fetchEquipmentsExportJob(this.props.cblId, this.props.exportJobsChargeCost.data[index].exportJobId, this.props.exportJobsChargeCost.data[index].essoRateDetailId, 1, this.state.equipmentsPageSize);
              }
              break;
            }
            default: {
              break;
            }
          }
          
          this.setState({
            isEquipmentsFetchinProgress: false,
          })
          
          this.props.setCurrentIndex(index);
          this.setSelected();
      }

      private resetSelection = (index: number, tableData: any) => {
        this.props.setCurrentIndex(index);
        this.setState(
          {
            setDefaultEquipmentsPage: true,
            handleEquipmentCall: true
          })
        
        setTimeout(() => {
          switch(this.props.target) {
            case CostColumnsData.TYPES.REVENUE : {
              if(this.props.exportJobsChargeRev.data.length > 0 && this.state.equipmentsPageSize > 0){
                this.props.fetchEquipmentsExportJob(this.props.cblId, this.props.exportJobsChargeRev.data[index].exportJobId, this.props.exportJobsChargeRev.data[index].essoRateDetailId, 1, this.state.equipmentsPageSize);
              }
              break;
            }
            case CostColumnsData.TYPES.COST : {
              if(this.props.exportJobsChargeCost.data.length > 0 && this.state.equipmentsPageSize > 0){
                this.props.fetchEquipmentsExportJob(this.props.cblId, this.props.exportJobsChargeCost.data[index].exportJobId, this.props.exportJobsChargeCost.data[index].essoRateDetailId, 1, this.state.equipmentsPageSize);
              }
              break;
            }
            default:{
              break;
            }
          }
        }, 50);

        this.setState({
          isEquipmentsFetchinProgress: false,
        })
      }

      private getExportJobsColumns(type: any) {
        return getExportJobsCols(type);
      }

      private getEquipmentColumns() {
        return getEquipmentCols();
      }

      private tableOrderFetch = (tableData: any) => {
        this.props.setPageExport(tableData.page + 1)
            const samePageRequest = (tableData.page + 1 !== this.state.exportJobPage || tableData.pageSize !== this.state.exportJobPageSize)  || tableData.sorted?.length > 0
            if (!this.state.isExportJobsFetchinProgress && samePageRequest) {
              if (tableData) {
                this.setState({
                  exportJobPage: tableData.page + 1,
                  exportJobPageSize: tableData.pageSize,
                  isExportJobsFetchinProgress: true
                }, () => {
                    if (tableData && tableData.sorted && tableData.sorted.length > 0 && tableData.sorted[0].id && tableData.sorted[0]!.id === 'messageDetails') {
                        this.setState({ isExportJobsFetchinProgress: false });
                        return
                    }
                    if (tableData && tableData.sorted) {
                        this.setState({ sorted: tableData.sorted });
                        setSortForCBLTable(tableData.sorted, this.props.setSort);
                    } else if (this.state.sorted && this.state.sorted.length) {
                        setSortForCBLTable(this.state.sorted, this.props.setSort);
                    }
                    this.fetchExportJobs(this.state.exportJobPage, this.state.exportJobPageSize);
                    this.resetSelection(0, tableData);
                });
              }
            }
      }

        private fetchExportJobs = (page: number, pageSize: number, column?: string, order?: number) => {
          this.setState({
            isExportJobsFetchinProgress: true
          })

          if(this.props.target === CostColumnsData.TYPES.REVENUE) {
            this.props.fetchExportJobsChargeRev(this.props.chargeItem.id, this.viewType, pageSize);
          }
          else{
            this.props.fetchExportJobsChargeCost(this.props.chargeItem.id, this.viewType, pageSize);
          }
        }

        private equipmentsTableOrderFetch = (tableData: any) => {
          if(this.state.setDefaultEquipmentsPage){
            this.props.setPageEquipment(1)
          }
          else{
            this.props.setPageEquipment(tableData.page + 1)
          }
          const samePageRequest = (tableData.page + 1 !== this.state.equipmentsPage || tableData.pageSize !== this.state.equipmentsPageSize)  || tableData.sorted?.length > 0
          if (!this.state.isEquipmentsFetchinProgress && samePageRequest) {
            if (tableData) {
              this.setState({
                  equipmentsPage: tableData.page + 1,
                  equipmentsPageSize: tableData.pageSize,
                  isEquipmentsFetchinProgress: true,
              }, () => {
                this.setState({setDefaultEquipmentsPage: false})
                  if (tableData && tableData.sorted && tableData.sorted.length > 0 && tableData.sorted[0].id && tableData.sorted[0]!.id === 'messageDetails') {
                      this.setState({ isEquipmentsFetchinProgress: false });
                      return
                  }
                  if (tableData && tableData.sorted) {
                      this.setState({ sorted: tableData.sorted });
                      setSortForCBLTable(tableData.sorted, this.props.setSort);
                  } else if (this.state.sorted && this.state.sorted.length) {
                      setSortForCBLTable(this.state.sorted, this.props.setSort);
                  }
                  this.fetchEquipments(tableData.page + 1, this.state.equipmentsPageSize);
                  this.setSelected();
              });
            }
          }
        }

        private fetchEquipments = (page: number, pageSize: number) => {
          this.setState({
            isEquipmentsFetchinProgress: true
          })
          const newPage = this.props.equipmentsForExportJob.totalCount < pageSize ? 1 : page

          if(this.props.target === CostColumnsData.TYPES.REVENUE) {
            if(this.props.exportJobsChargeRev.data.length > 0){
              this.props.fetchEquipmentsExportJob(this.props.cblId, this.props.exportJobsChargeRev.data[this.props.index].exportJobId, this.props.exportJobsChargeRev.data[this.props.index].essoRateDetailId, newPage, pageSize);
            }
          }
          else{
            if(this.props.exportJobsChargeCost.data.length > 0){
              this.props.fetchEquipmentsExportJob(this.props.cblId, this.props.exportJobsChargeCost.data[this.props.index].exportJobId, this.props.exportJobsChargeCost.data[this.props.index].essoRateDetailId, newPage, pageSize);
            }
          }
        }

        private updatesComponentUpdate(){
          this.setState({
            isExportJobsFetchinProgress: false,
            isEquipmentsFetchinProgress: false,
            isEventAdded: false,
          });

          setTimeout(() => {
            this.props.setCurrentIndex(this.props.index);
            this.setSelected();
          }, 200);
        }
        
     }

  const mapStateToProps = (state: IStore): IMapStateToProps => ({
    isFetchDataLoading: state.costRevenue.isFetchDataLoading,
    exportJobsChargeRev: state.costRevenue.exportJobsChargeRev,
    exportJobsChargeCost: state.costRevenue.exportJobsChargeCost,
    equipmentsForExportJob: state.costRevenue.equipmentsForExportJob,
    exportPage: state.filters.exportPage,
    equipmentPage: state.filters.exportPage
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
  fetchExportJobsChargeRev: (id: number, viewType?: number, pageSize?: number) => dispatch(fetchExportJobsChargeRev(id, viewType, pageSize)),
  fetchExportJobsChargeCost: (id: number, viewType?: number, pageSize?: number) => dispatch(fetchExportJobsChargeCost(id, viewType, pageSize)),
  fetchEquipmentsExportJob: (id: number, exportJobId: number, essoRateDetailId: number, page?: number, pageSize?: number) => dispatch(fetchEquipmentsExportJob(id, exportJobId, essoRateDetailId, page, pageSize)),
  resetSort: () => dispatch(resetSort()),
  setSort: (sort: ISortModel) => dispatch(setSort(sort)),
  setPageExport: (page: number) => dispatch(setPageExport(page)),
  setPageEquipment: (page: number) => dispatch(setPageEquipment(page)),
});
const ExportJobDetailsTable = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_ExportJobDetailsTable);

export default ExportJobDetailsTable;